import Documents from "../../components/Documents";
function DocumentsPage() {
  return (
    <div>
      <Documents />
    </div>
  );
}

export default DocumentsPage;
